import { Icon } from '@components/icons';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';
import { prettifyCardStars } from '@utils/index';

const SetPreferredCardModal = () => {
    const { modalData } = useModalContext();
    return (
        <div className={styles.wrapper}>
            <Icon name="check_outlined" width={60} height={60} />
            <Typography variant="h5">
                {modalData?.card_brand} ({prettifyCardStars(modalData?.card_number)})
            </Typography>
            <Typography variant="h5" weight="medium" className={styles.title}>
                will be set as your preferred payment method
            </Typography>
        </div>
    );
};

export default SetPreferredCardModal;
